import React, { useState } from "react";
import { Table  } from "antd";
import moment from "moment";
import { useCentralStore } from "../../../store/appContext";
import { numberWithCommas } from "../../../utils/functionUtils";

const SalesReportTable = ({
  salesReportData,
  MetricsLabel,
}) => {
  const [
    {
      carrierThemeData
    },
    dispatch,
  ] = useCentralStore();
  const { theme } = carrierThemeData;

  let tableColumns = [];
  const totalKeys = {};

  salesReportData?.reduce((acc, current) => {
    const keys = Object.keys(current);
    for (var i in keys) {
      totalKeys[keys[i]] = 1;
    }
  }, totalKeys);

  var keys = Object.keys(totalKeys);
  for (var i in keys) {
    tableColumns.push({
      title: keys[i]?.replace('TrainingCategory', 'category')?.replace(/([a-z0-9])([A-Z])/g, "$1 $2")?.toUpperCase(),
      dataIndex: keys[i],
      key: keys[i],
      width: 280
    });
  }

  const getPartsColumns = () => {
    let headerColumns = [];
    tableColumns.forEach((c, i) => {
        headerColumns.push({
          ...c,
        });
    });
    return headerColumns;
  };

  const reportDetailsSuccessData = function (salesReportData) {
      return salesReportData?.map((obj) => {
        let dateObj = {};
        Object.entries(obj)?.map(
          ([key, value]) =>
            (dateObj[key] = key?.toUpperCase()?.includes("VOLUME")
              ? numberWithCommas(value)
              : value)
        );
        return dateObj;
      });
  };

  const [currentSearchedData, setCurrentSearchedData] = useState(undefined);

  const handleTableChange = (currentPagination, filters, sorter, extra) => {
    let isFilter = false;
    for (let objKey in filters) {
      setCurrentSearchedData(extra?.currentDataSource);
    }
    if (isFilter === false) {
      setCurrentSearchedData(undefined);
    }
  };

  const dynamicStyle = {
    '--th-header': theme?.colors?.textWhiteColor,
  }

  return (
    <div className="mx-auto py-3 w-full">
      <Table
        columns={getPartsColumns()}
        dataSource={currentSearchedData || reportDetailsSuccessData(salesReportData)}
        onChange={handleTableChange}
        // style={{ fontSize: "10px !important" }}
        style={dynamicStyle}
        rowKey="data"
        key="data"
        className="table-css border-current border-white mb-5"
        locale={{ emptyText: "No data" }}
        pagination={false}
      />
    </div>
  );
};

export default SalesReportTable;
